import { baseDefaultContextProps } from '../../constants/props';
import { createComment, deleteComment, getComments, updateComment } from '../../data/api/commentsApi';
import { fetchExternalOptions } from '../../data/api/propertiesApi';
import { fetchRenderedContent, fetchUnrenderedContent, searchSnippets } from '../../data/api/snippetsApi';
export const defaultCommentsProps = Object.assign({}, baseDefaultContextProps, {
  isStickyFooterHidden: false,
  hubspotUserId: 0,
  apiWrapper: {
    getComments,
    createComment,
    deleteComment,
    updateComment,
    fetchOwners: fetchExternalOptions,
    snippets: {
      fetchRenderedContent,
      fetchUnrenderedContent,
      searchSnippets
    }
  },
  prosemirrorTrackerProperties: undefined
});